// import * as React from 'react';
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { TextField, MenuItem } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { GLOBAL_URL, getRequestGlobal } from "../../../API/global";
import { validateFile } from "../../Helper";
const AddressIdentification = ({
  formData,
  setFormData,
  errors,
  setAddressDetailsErrors,
}) => {
  const [selectedFirstGovtIdProof, setSelectedFirstGovtIdProof] =
    useState(null);
  const [selectedSecondGovtIdProof, setSelectedSecondGovtIdProof] =
    useState(null);

  const [city, setCity] = useState({});
  const [residencecity, setResidencecity] = useState({});
  const [state, setState] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == "permanent_state") {
      loadpermanentCity(value);
    }
    if (name == "residence_state") {
      loadresidenceCity(value);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
    errors[name] = "";
    setAddressDetailsErrors(errors);
  };

  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    if (checked) {
      getRequestGlobal("city", { state_id: formData.permanent_state })
        .then((data) => {
          setResidencecity(data.data);
          setFormData({
            ...formData,
            [name]: checked ? 1 : 0,
            // residence_address: '',
            // residence_state: '',
            // residence_city: '',
            // residence_state_of_origin_id: ''
          });
        })
        .catch((error) => {});
    } else if (!checked) {
      setFormData({
        ...formData,
        [name]: checked ? 1 : 0,
      });
      if (
        formData.residence_address == "" ||
        formData.residence_state == "" ||
        formData.residence_city == ""
      ) {
        setFormData({
          ...formData,
          [name]: checked ? 1 : 0,
          residence_address: formData.residence_address,
          residence_state: formData.residence_state,
          residence_city: formData.residence_city,
        });
      }
    } else {
      errors[name] = "";
      setAddressDetailsErrors(errors);
    }
  };

  const loadpreData = async () => {
    //  const data1 = await getRequestGlobal('city', {})
    //const data2 = await getRequestGlobal('state', {})
  };
  const loadpermanentCity = (state_id) => {
    // console.log({ state_id })
    getRequestGlobal("city", { state_id })
      .then((data) => {
        setCity(data.data);
      })
      .catch((error) => {});
  };
  const loadresidenceCity = (state_id) => {
    // console.log({ state_id })

    getRequestGlobal("city", { state_id })
      .then((data) => {
        setResidencecity(data.data);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getRequestGlobal("state", {})
      .then((data) => {
        setState(data.data);
        // console.log({ permanent_state: formData.permanent_state });
        if (formData.permanent_state) {
          loadpermanentCity(formData.permanent_state);
        }
        if (formData.residence_state) {
          loadresidenceCity(formData.residence_state);
        }
      })
      .catch((error) => {});
  }, []);

  const handleSelectedGovtFirstIdProof = (event) => {
    setSelectedFirstGovtIdProof(event.target.files[0]);
    // console.log("first_gov_id_proof success")
    const firstGovtIdProof = event.target.files[0];
    const validateFirstID = validateFile(firstGovtIdProof);

    if (!validateFirstID["status"]) {
      setAddressDetailsErrors({
        is_first_gov_id_proof: validateFirstID.message,
      });
    } else {
      // console.log(firstGovtIdProof);
      setFormData((prevState) => ({
        ...prevState,
        first_gov_id_proof: firstGovtIdProof,
        is_first_gov_id_proof: 1,
      }));

      setAddressDetailsErrors({
        is_first_gov_id_proof: "",
      });
    }
  };

  const handleSelectedGovtSecondIdProof = (event) => {
    setSelectedSecondGovtIdProof(event.target.files[0]);
    // console.log("second_gov_id_proof success")
    const secondGovtIdProof = event.target.files[0];
    const validateSecondID = validateFile(secondGovtIdProof);

    if (!validateSecondID["status"]) {
      setAddressDetailsErrors({
        is_second_gov_id_proof: validateSecondID.message,
      });
    } else {
      // console.log(secondGovtIdProof);
      setFormData((prevState) => ({
        ...prevState,
        second_gov_id_proof: secondGovtIdProof,
        is_second_gov_id_proof: 1,
      }));

      setAddressDetailsErrors((prevErrors) => ({
        ...prevErrors,
        is_second_gov_id_proof: "",
      }));
    }
  };

  return (
    <>
      <div className="cmot-phone">
        <h5>STEP 2</h5>
        <p>
          Address Identification <span className="text-danger">*</span>
        </p>
      </div>
      <form>
        <Grid container spacing={2} className="mt-3">
          <Grid item xs={12} sm={12} md={12} lg={12} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Permanent Address"
                type="text"
                fullWidth
                multiline
                name="permanent_address"
                value={formData.permanent_address}
                onChange={handleChange}
                error={!!errors.permanent_address}
                helperText={errors.permanent_address}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} className="p-1">
            <Box>
              <TextField
                id="State/UT"
                fullWidth
                label="State/UT"
                select
                value={formData.permanent_state || ""}
                onChange={handleChange}
                error={!!errors.permanent_state}
                helperText={errors.permanent_state}
                variant="outlined"
                name="permanent_state"
              >
                {/* {Object.entries(state).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))} */}
                {Object.entries(state)
                  .sort((a, b) => a[1].localeCompare(b[1])) // Sort by value alphabetically
                  .map(([key, value]) => (
                    <MenuItem key={key} value={key}>
                      {value}
                    </MenuItem>
                  ))}
              </TextField>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} className="p-1">
            <Box>
              <TextField
                id="City"
                fullWidth
                label="City"
                select
                variant="outlined"
                name="permanent_city"
                value={formData.permanent_city || ""}
                onChange={handleChange}
                error={!!errors.permanent_city}
                helperText={errors.permanent_city}
              >
                <MenuItem key={0} value="">
                  Please select the city
                </MenuItem>
                {/* {Object.entries(city).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))} */}
                {Object.entries(city)
                  .sort((a, b) => a[1].localeCompare(b[1])) // Sort by value alphabetically
                  .map(([key, value]) => (
                    <MenuItem key={key} value={key}>
                      {value}
                    </MenuItem>
                  ))}
              </TextField>
            </Box>
          </Grid>

          {/* <Grid item xs={12} sm={12} md={6} lg={6} className="p-1">
            <Box>
              <TextField
                id="State/UT of Origin"
                name="state_of_origin_id"
                fullWidth
                label="State/UT of Origin"
                select
                value={formData.state_of_origin_id}
                onChange={handleChange}
                error={!!errors.state_of_origin_id}
                helperText={errors.state_of_origin_id}
                variant="outlined"
              >
                {Object.entries(state).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid> */}

          {/* Check Box */}
          <Grid item xs={12} sm={12} md={6} lg={12} className="p-1">
            <FormGroup>
              <FormControlLabel
                name="address_confirmation"
                control={
                  <Checkbox
                    checked={formData.address_confirmation ? true : false}
                    onChange={handleChangeCheckbox}
                    style={{ color: "#2C3E50" }}
                    className="checkboxcmot"
                  />
                }
                label="Check If the Permanent Address And residence Address Are the Same"
              />
            </FormGroup>
          </Grid>
          {formData.address_confirmation ? (
            <></>
          ) : (
            <>
              <Grid item xs={12} sm={12} md={12} lg={12} className="p-1">
                <Box>
                  <TextField
                    variant="outlined"
                    label="Residence Address"
                    type="text"
                    fullWidth
                    multiline
                    name="residence_address"
                    value={formData.residence_address}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: !!formData.residence_address,
                    }}
                    error={!!errors.residence_address}
                    helperText={errors.residence_address}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} className="p-1">
                <Box>
                  <TextField
                    variant="outlined"
                    label="State/UT"
                    type="text"
                    fullWidth
                    select
                    name="residence_state"
                    value={formData.residence_state}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: !!formData.residence_state,
                    }}
                    error={!!errors.residence_state}
                    helperText={errors.residence_state}
                  >
                    {Object.entries(state).map(([key, value]) => (
                      <MenuItem key={key} value={key}>
                        {value}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} className="p-1">
                <Box>
                  <TextField
                    variant="outlined"
                    label="City"
                    select
                    fullWidth
                    name="residence_city"
                    value={formData.residence_city}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: !!formData.residence_city,
                    }}
                    error={!!errors.residence_city}
                    helperText={errors.residence_city}
                  >
                    <MenuItem key={0} value="">
                      Please select the city
                    </MenuItem>
                    {Object.entries(residencecity).map(([key, value]) => (
                      <MenuItem key={key} value={key}>
                        {value}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              </Grid>
            </>
          )}
          <Grid item xs={12} sm={12} md={6} lg={6} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="First Govt. ID Number"
                // type="text"
                type="text"
                fullWidth
                name="first_govt_id_number"
                helperText="Govt. ID ( Aadhar Card/Voter ID/Passport/Driving Licence/PAN Card )"
                value={formData.first_govt_id_number}
                onChange={handleChange}
                onInput={(e) => {
                  if (e.target.value.length > 20)
                    e.target.value = e.target.value.slice(0, 20);
                }}
                error={!!errors.first_govt_id_number}
                // helperText={errors.first_govt_id_number}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} className="p-1">
            {/* <Box>
                            <TextField
                                type="file"
                                variant="outlined"
                                label="upload First Govt. ID Proof"
                                fullWidth
                                name="first_gov_id_proof"
                                helperText="Please upload ( jpg, png or pdf format document) Name to be clearly visible"
                                InputLabelProps={{
                                    shrink: true,
                                    sx: {
                                        color: '#632340',
                                    },
                                }}
                                value={formData.first_gov_id_proof}
                                onChange={handleChange}
                          
                                error={!!errors.first_gov_id_proof}
                            helperText={errors.first_gov_id_proof}
                            />
                        </Box> */}

            <Box>
              <input
                type="file"
                accept=".pdf,.jpeg,.jpg"
                onChange={handleSelectedGovtFirstIdProof}
                style={{ display: "none", width: "100%" }}
                id="synopsis"
                name="first_gov_id_proof"
              />
              <label
                htmlFor="synopsis"
                style={{ width: "100%", height: "100%" }}
              >
                <TextField
                  variant="outlined"
                  placeholder="Upload First Govt. ID Proof"
                  value={
                    selectedFirstGovtIdProof
                      ? selectedFirstGovtIdProof.name
                      : ""
                  }
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            document.getElementById("synopsis").click()
                          }
                          edge="end"
                        >
                          <AttachFileIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
                {errors.is_first_gov_id_proof && (
                  <p className="text-danger">{errors.is_first_gov_id_proof}</p>
                )}
                {!formData?.documentData?.[1] ? (
                  <></>
                ) : (
                  <div>
                    <span className="Attach_Photo_ID">
                      <a
                        href={`${GLOBAL_URL}downloadfile/cmot/${formData.id}/${formData?.documentData?.[1].file}`}
                      >
                        {formData?.documentData?.[1].name}
                      </a>
                    </span>
                  </div>
                )}
              </label>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Second Govt. ID Number"
                // type="text"
                type="text"
                fullWidth
                name="second_govt_id_number"
                helperText="Aadhar Card/Voter ID/Passport/Driving Licence/PAN Card-It should be different from first ID proof"
                value={formData.second_govt_id_number}
                onChange={handleChange}
                onInput={(e) => {
                  if (e.target.value.length > 20)
                    e.target.value = e.target.value.slice(0, 20);
                }}
                error={!!errors.second_govt_id_number}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} className="p-1">
            {/* <Box>
                            <TextField
                                type="file"
                                variant="outlined"
                                label="Upload Second Govt. ID Proof"
                                fullWidth
                                name="second_gov_id_proof"
                                helperText="Please upload jpg, png or pdf format document-It should be different from first ID proof (Name to be clearly visible)"
                                InputLabelProps={{
                                    shrink: true,
                                    sx: {
                                        color: '#632340'
                                    },
                                }}
                                value={formData.second_gov_id_proof}
                                onChange={handleChange}
                                error={!!errors.second_gov_id_proof}
                            />
                        </Box> */}

            <Box>
              <input
                type="file"
                accept=".pdf,.jpeg,.jpg"
                onChange={handleSelectedGovtSecondIdProof}
                style={{ display: "none", width: "100%" }}
                id="profileOfCreator"
                name="second_gov_id_proof"
              />
              <label
                htmlFor="profileOfCreator"
                style={{ width: "100%", height: "100%" }}
              >
                <TextField
                  variant="outlined"
                  placeholder="Upload Second Govt. ID Proof"
                  value={
                    selectedSecondGovtIdProof
                      ? selectedSecondGovtIdProof.name
                      : ""
                  }
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            document.getElementById("profileOfCreator").click()
                          }
                          edge="end"
                        >
                          <AttachFileIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
                {errors.is_second_gov_id_proof && (
                  <p className="text-danger">{errors.is_second_gov_id_proof}</p>
                )}
                {!formData?.documentData?.[2] ? (
                  <></>
                ) : (
                  <div>
                    <span className="Attach_Photo_ID">
                      <a
                        href={`${GLOBAL_URL}downloadfile/cmot/${formData.id}/${formData?.documentData?.[2].file}`}
                      >
                        {formData?.documentData?.[2].name}
                      </a>
                    </span>
                  </div>
                )}
              </label>
            </Box>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default AddressIdentification;
